const Influencers = {
  followTheSteps: 'Siga os passos para realizar',
  InfluencerStep1: 'Ter no mínimo 300 mil seguidores.',
  InfluencerStep2:
    'Envie seu email e a URL do seu sorteio para o nosso Instagram @instasorteioo através do seu perfil.',
  InfluencerStep3: 'Aguarde o seu sorteio ser autorizado (24 horas úteis).',
};

export default Influencers;
